import {charHasRotatedVerticalOrientation} from './script_detection';

export const verticalizedCharacterMap = {
    '!': 'Ã¯Â¸Â•',
    '#': 'Ã¯Â¼Âƒ',
    '$': 'Ã¯Â¼Â„',
    '%': 'Ã¯Â¼Â…',
    '&': 'Ã¯Â¼Â†',
    '(': 'Ã¯Â¸Âµ',
    ')': 'Ã¯Â¸Â¶',
    '*': 'Ã¯Â¼ÂŠ',
    '+': 'Ã¯Â¼Â‹',
    ',': 'Ã¯Â¸Â',
    '-': 'Ã¯Â¸Â²',
    '.': 'Ã£ÂƒÂ»',
    '/': 'Ã¯Â¼Â',
    ':': 'Ã¯Â¸Â“',
    ';': 'Ã¯Â¸Â”',
    '<': 'Ã¯Â¸Â¿',
    '=': 'Ã¯Â¼Â',
    '>': 'Ã¯Â¹Â€',
    '?': 'Ã¯Â¸Â–',
    '@': 'Ã¯Â¼Â ',
    '[': 'Ã¯Â¹Â‡',
    '\\': 'Ã¯Â¼Â¼',
    ']': 'Ã¯Â¹Âˆ',
    '^': 'Ã¯Â¼Â¾',
    '_': 'Ã¯Â¸Â³',
    '`': 'Ã¯Â½Â€',
    '{': 'Ã¯Â¸Â·',
    '|': 'Ã¢Â€Â•',
    '}': 'Ã¯Â¸Â¸',
    '~': 'Ã¯Â½Âž',
    'Ã‚Â¢': 'Ã¯Â¿Â ',
    'Ã‚Â£': 'Ã¯Â¿Â¡',
    'Ã‚Â¥': 'Ã¯Â¿Â¥',
    'Ã‚Â¦': 'Ã¯Â¿Â¤',
    'Ã‚Â¬': 'Ã¯Â¿Â¢',
    'Ã‚Â¯': 'Ã¯Â¿Â£',
    'Ã¢Â€Â“': 'Ã¯Â¸Â²',
    'Ã¢Â€Â”': 'Ã¯Â¸Â±',
    'Ã¢Â€Â˜': 'Ã¯Â¹Âƒ',
    'Ã¢Â€Â™': 'Ã¯Â¹Â„',
    'Ã¢Â€Âœ': 'Ã¯Â¹Â',
    'Ã¢Â€Â': 'Ã¯Â¹Â‚',
    'Ã¢Â€Â¦': 'Ã¯Â¸Â™',
    'Ã¢Â€Â§': 'Ã£ÂƒÂ»',
    'Ã¢Â‚Â©': 'Ã¯Â¿Â¦',
    'Ã£Â€Â': 'Ã¯Â¸Â‘',
    'Ã£Â€Â‚': 'Ã¯Â¸Â’',
    'Ã£Â€Âˆ': 'Ã¯Â¸Â¿',
    'Ã£Â€Â‰': 'Ã¯Â¹Â€',
    'Ã£Â€ÂŠ': 'Ã¯Â¸Â½',
    'Ã£Â€Â‹': 'Ã¯Â¸Â¾',
    'Ã£Â€ÂŒ': 'Ã¯Â¹Â',
    'Ã£Â€Â': 'Ã¯Â¹Â‚',
    'Ã£Â€ÂŽ': 'Ã¯Â¹Âƒ',
    'Ã£Â€Â': 'Ã¯Â¹Â„',
    'Ã£Â€Â': 'Ã¯Â¸Â»',
    'Ã£Â€Â‘': 'Ã¯Â¸Â¼',
    'Ã£Â€Â”': 'Ã¯Â¸Â¹',
    'Ã£Â€Â•': 'Ã¯Â¸Âº',
    'Ã£Â€Â–': 'Ã¯Â¸Â—',
    'Ã£Â€Â—': 'Ã¯Â¸Â˜',
    'Ã¯Â¼Â': 'Ã¯Â¸Â•',
    'Ã¯Â¼Âˆ': 'Ã¯Â¸Âµ',
    'Ã¯Â¼Â‰': 'Ã¯Â¸Â¶',
    'Ã¯Â¼ÂŒ': 'Ã¯Â¸Â',
    'Ã¯Â¼Â': 'Ã¯Â¸Â²',
    'Ã¯Â¼ÂŽ': 'Ã£ÂƒÂ»',
    'Ã¯Â¼Âš': 'Ã¯Â¸Â“',
    'Ã¯Â¼Â›': 'Ã¯Â¸Â”',
    'Ã¯Â¼Âœ': 'Ã¯Â¸Â¿',
    'Ã¯Â¼Âž': 'Ã¯Â¹Â€',
    'Ã¯Â¼ÂŸ': 'Ã¯Â¸Â–',
    'Ã¯Â¼Â»': 'Ã¯Â¹Â‡',
    'Ã¯Â¼Â½': 'Ã¯Â¹Âˆ',
    'Ã¯Â¼Â¿': 'Ã¯Â¸Â³',
    'Ã¯Â½Â›': 'Ã¯Â¸Â·',
    'Ã¯Â½Âœ': 'Ã¢Â€Â•',
    'Ã¯Â½Â': 'Ã¯Â¸Â¸',
    'Ã¯Â½ÂŸ': 'Ã¯Â¸Âµ',
    'Ã¯Â½Â ': 'Ã¯Â¸Â¶',
    'Ã¯Â½Â¡': 'Ã¯Â¸Â’',
    'Ã¯Â½Â¢': 'Ã¯Â¹Â',
    'Ã¯Â½Â£': 'Ã¯Â¹Â‚'
};

export function verticalizePunctuation(input: string) {
    let output = '';

    for (let i = 0; i < input.length; i++) {
        const nextCharCode = input.charCodeAt(i + 1) || null;
        const prevCharCode = input.charCodeAt(i - 1) || null;

        const canReplacePunctuation = (
            (!nextCharCode || !charHasRotatedVerticalOrientation(nextCharCode) || verticalizedCharacterMap[input[i + 1]]) &&
            (!prevCharCode || !charHasRotatedVerticalOrientation(prevCharCode) || verticalizedCharacterMap[input[i - 1]])
        );

        if (canReplacePunctuation && verticalizedCharacterMap[input[i]]) {
            output += verticalizedCharacterMap[input[i]];
        } else {
            output += input[i];
        }
    }

    return output;
}

